import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, NgClass],
})
export class SearchBarComponent {
  @Input() placeholder!: string;
  @Output() searchTermChanged = new EventEmitter();

  searchTerm: string = '';
  isSearchBarFocused = false;
  isFilledAndBlurred = false;

  onSearchBarFocused() {
    this.isSearchBarFocused = true;
  }

  onSearchBarBlurred() {
    this.searchTerm = this.searchTerm.trim();
    this.isSearchBarFocused = false;

    if (this.searchTerm) {
      this.isFilledAndBlurred = true;
      return;
    }

    this.isFilledAndBlurred = false;
  }

  onSearchTermChanged(value: string) {
    this.searchTerm = value;
    this.searchTermChanged.emit(value);
  }
}
